import { render, staticRenderFns } from "./ComissionTable.vue?vue&type=template&id=9f96ad76&"
import script from "./ComissionTable.vue?vue&type=script&lang=js&"
export * from "./ComissionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports